module.exports = __webpack_public_path__ + "static/media/animated-2.77d46804.gif";